export default "/fonts/Poppins-Light.ttf?53e02b634e42240b89d8cd942c7a4ae8";